export function getWeekdayLabel(dateString, locale) {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return date.toLocaleDateString(locale, { weekday: "long" });
}

export function getMonthDayLabel(dateString, locale) {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return date.toLocaleDateString(locale, { month: "short", day: "numeric" });
}
